export class ResPeriodStatus {
    Period: string;
    Count:number;
    Status?: string;  //Full|Avaliable
}

export class ReservationPeriod {
    HHMM: string;
    Status: string;
    Icon: string;
    Class: string;
    Disabled: boolean;

    constructor(init?: Partial<ReservationPeriod>) {
        Object.assign(this, init);
    }
}

export class ReservationSign{
    CompanyID: string;
    UserID: string;
    SignPath: string;
}